import React from 'react';

interface Props {
  valueState: number;
  setValueState: (_newValue: number) => void;
  numberChange?: number;
  prefix?: string;
  suffix?: string;
  downLimit?: number;
  upperLimit?: number;
  showOnlySuffix?: boolean;
  isEditable?: boolean;
}

export const ToggleNumberInput: React.FC<Props> = ({
  numberChange = 1,
  prefix = '',
  suffix = '',
  setValueState,
  valueState,
  downLimit = 0,
  upperLimit = 4,
  showOnlySuffix = false,
  isEditable = true,
}) => {
  const handleIncrement = () => {
    if (!upperLimit || upperLimit > valueState) setValueState(valueState + numberChange);
  };

  const handleDecrement = () => {
    if (downLimit < valueState || downLimit === undefined) {
      setValueState(valueState - numberChange);
    }
  };

  return isEditable ? (
    <div className="flex flex-1 flex-row  border border-gray-450 rounded  ">
      <button onClick={handleDecrement} className="text-blue-600 font-bold px-[0.75rem] text-lg">
        -
      </button>
      <div className="px-[0.75rem] border-x border-gray-450 min-w-[3rem] text-center flex-1">
        {showOnlySuffix ? suffix : prefix + valueState + suffix}
      </div>
      <button onClick={handleIncrement} className="text-blue-600 font-bold px-[0.75rem] text-lg">
        +
      </button>
    </div>
  ) : (
    <div className="flex flex-1 flex-row  rounded  ">{showOnlySuffix ? suffix : prefix + valueState + suffix}</div>
  );
};
